import en from "./index.en";

export default {
	en,
	"en-US": en,
};
